





















import { Component, Vue } from 'vue-property-decorator'
import { ITuileNav } from '@/models/ui/ITuileNav'
import { getImageUrl } from '@/utils/images'


@Component({
  name:"ListeTuilePres",
  components: {    
  },
  props:{    
    items:Array,
    fluid:{
      type:Boolean,
      default:true
    },
    showActionBtn:{      
      type:Boolean,
      default:true
    }
  }
})
export default class ListeTuilePres extends Vue {    
  items!:Array<ITuileNav>  
  fluid!:Boolean
  showActionBtn!:Boolean

  get getImageUrl(){
    return getImageUrl
  }
   
}
